<app-header [title]="'Passports'" [notificationsCount]="commentsNotification.unreadCount()" [showSearchIcon]="true" [showFilterIcon]="true" [showDesktopFilters]="true" [filterDefinitions]="transloadFilters" (refresh)="onRefresh()"></app-header>

<div class="transloading-page" [style.paddingTop.px]="(ui.searchOpen() || ui.filtersOpen()) ? 0 : 50">
  <div class="mobile-view">
    <app-status-tabs [pendingCount]="pendingCount()"
      [outgoingCount]="outgoingCount()"
      [completedCount]="completedCount()"></app-status-tabs>

    <app-no-passports *ngIf="visibleRecords().length === 0"></app-no-passports>

    <ng-container *ngFor="let rec of visibleRecords(); trackBy: trackById; let i = index">
      <app-transloading-passport-cell [recordId]="rec.id"
        [loadNumber]="detailsStore.get(rec.id)?.loadNumber || rec.id"
        [scheduledText]="((detailsStore.get(rec.id)?.dueDateTime) | dateWithOrdinal:'EEE, d MMM y, HH:mm') || 'No scheduled date'"
        [vendorName]="detailsStore.get(rec.id)?.vendorName || ''"
        [variety]="detailsStore.get(rec.id)?.variety || ''"
        [bulkerNumber]="detailsStore.get(rec.id)?.bulkerMain || detailsStore.get(rec.id)?.bulkerNumber || ''"
        [haulier]="detailsStore.get(rec.id)?.haulier || ''"
        [origin]="detailsStore.get(rec.id)?.origin || ''"
        [destination]="detailsStore.get(rec.id)?.destinationWeighbridge || detailsStore.get(rec.id)?.destination || ''"
        [apn]="detailsStore.get(rec.id)?.apn || ''"
        [apnName]="detailsStore.get(rec.id)?.apnName || ''"
        [vendorNumber]="detailsStore.get(rec.id)?.vendorNumber || ''"
        [status]="rec.status"
        [styleState]="getStyleState(rec.id)"
        [class.expanded]="ui.expandedRecordId() === rec.id"></app-transloading-passport-cell>
      <div class="passport-cell-spacer"></div>
    </ng-container>
  </div>

  <!-- Desktop View -->
  <div class="desktop-view">
    <!-- Status Buttons Row Template -->
    <ng-template #statusButtonsRow>
      <div class="desktop-status-row">
        <div class="status-tabs-group">
          <button type="button" class="desktop-status-btn" 
                  [class.selected]="ui.statusSelected() === 'pending'"
                  (click)="onStatusTabSelect('pending')">
            Pending Passports ({{ pendingCount() }})
          </button>
          <button type="button" class="desktop-status-btn" 
                  [class.selected]="ui.statusSelected() === 'completed'"
                  (click)="onStatusTabSelect('completed')">
            Completed Passports ({{ completedCount() }})
          </button>
        </div>
        
        <app-desktop-status-row
          [itemsPerPage]="itemsPerPage"
          [rowsDropdownOpen]="rowsDropdownOpen"
          (toggleRowsDropdown)="toggleRowsDropdown($event)"
          (setItemsPerPage)="setItemsPerPage($event)"
          (refresh)="onRefresh()">
        </app-desktop-status-row>
      </div>
    </ng-template>


    @if (sortedPaginatedRecords.length > 0) {
      <!-- Main White Container -->
      <div class="desktop-main-container">
        <!-- Status Buttons Row -->
        <ng-container *ngTemplateOutlet="statusButtonsRow"></ng-container>

        <!-- Table Container -->
        <div class="desktop-table-container">
          <table class="desktop-passports-table">
            <thead>
              <tr>
                <th (click)="onSort('loadNumber')" (keydown.enter)="onSort('loadNumber')" (keyup.enter)="onSort('loadNumber')" tabindex="0">Load <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('scheduled')" (keydown.enter)="onSort('scheduled')" (keyup.enter)="onSort('scheduled')" tabindex="0">Scheduled <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('vendorCombined')" (keydown.enter)="onSort('vendorCombined')" (keyup.enter)="onSort('vendorCombined')" tabindex="0">Vendor Number/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('variety')" (keydown.enter)="onSort('variety')" (keyup.enter)="onSort('variety')" tabindex="0">Variety <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('origin')" (keydown.enter)="onSort('origin')" (keyup.enter)="onSort('origin')" tabindex="0">Origin <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('destination')" (keydown.enter)="onSort('destination')" (keyup.enter)="onSort('destination')" tabindex="0">Destination <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('haulier')" (keydown.enter)="onSort('haulier')" (keyup.enter)="onSort('haulier')" tabindex="0">Haulier <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('apnName')" (keydown.enter)="onSort('apnName')" (keyup.enter)="onSort('apnName')" tabindex="0">APN/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('bulkerNumber')" (keydown.enter)="onSort('bulkerNumber')" (keyup.enter)="onSort('bulkerNumber')" tabindex="0">Bulker Number <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th class="col-actions-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (rec of sortedPaginatedRecords; track trackById($index, rec)) {
                <tr [attr.data-passport-id]="rec.id"
                    [class.has-pcr-changes]="detailsStore.get(rec.id)?.hasSeenPcrChanges === false && (detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() !== 'cancelled'"
                    [class.is-cancelled]="(detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() === 'cancelled'">
                  <td class="col-load-number" 
                      (click)="(detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      (keydown.enter)="(detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      (keyup.enter)="(detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      [tabindex]="(detailsStore.get(rec.id)?.loadStatusName || '').toLowerCase() !== 'cancelled' ? 0 : -1">
                    {{ detailsStore.get(rec.id)?.loadNumber || rec.id }}
                  </td>
                  <td>
                    <app-formatted-date [dueDateTime]="detailsStore.get(rec.id)?.dueDateTime"></app-formatted-date>
                  </td>
                  <td>{{ (detailsStore.get(rec.id)?.vendorNumber || '') + ' - ' + (detailsStore.get(rec.id)?.vendorName || '') }}</td>
                  <td>{{ detailsStore.get(rec.id)?.variety || '-' }}</td>
                  <td>{{ detailsStore.get(rec.id)?.origin || 'No Origin Field' }}</td>
                  <td>{{ detailsStore.get(rec.id)?.destinationWeighbridge || detailsStore.get(rec.id)?.destination || '-' }}</td>
                  <td>{{ detailsStore.get(rec.id)?.haulier || '-' }}</td>
                  <td>{{ detailsStore.get(rec.id)?.apnName || detailsStore.get(rec.id)?.apn || '-' }}</td>
                  <td>{{ detailsStore.get(rec.id)?.bulkerMain || detailsStore.get(rec.id)?.bulkerNumber || '-' }}</td>
                  <app-action-buttons 
                    [recordId]="rec.id"
                    (history)="openHistory($event)"
                    (comments)="openComments($event)">
                  </app-action-buttons>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <app-desktop-pagination 
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          [totalPages]="totalPages"
          [visibleRecordsLength]="visibleRecords().length"
          (pageChange)="onPageChange($event)">
        </app-desktop-pagination>
      </div>
    } @else {
      <div class="desktop-empty-container">
        <!-- Status Buttons Row for Empty State -->
        <div class="desktop-main-container empty-state-header">
          <ng-container *ngTemplateOutlet="statusButtonsRow"></ng-container>
        </div>

        <app-desktop-empty-state></app-desktop-empty-state>
      </div>
    }
  </div>
</div>

<app-loading-spinner [isLoading]="isLoading()" [largeOnDesktop]="true" [text]="isFirstLoad && !isDesktopView ? 'Syncing data for offline use…' : 'Loading passports…'"></app-loading-spinner>

<app-navbar [items]="navbarItems" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>


